export default {
    toggleFormState(state, payload)
    {
        state.is_opened = payload;
    },
}
